import { render, staticRenderFns } from "./VvButtonReverse.vue?vue&type=template&id=d9c60b88&scoped=true&"
import script from "./VvButtonReverse.vue?vue&type=script&lang=js&"
export * from "./VvButtonReverse.vue?vue&type=script&lang=js&"
import style0 from "./VvButtonReverse.vue?vue&type=style&index=0&id=d9c60b88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c60b88",
  null
  
)

export default component.exports